exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, ".scrollableList___1HHnG {\n  max-height: 283px;\n  overflow-y: auto;\n  width: 100%; }\n", "", {"version":3,"sources":["/Users/fdev/code/factorial/factorial-components/src/components/ScrollableList/src/components/ScrollableList/index.scss"],"names":[],"mappings":"AAAA;EACE,kBAAiB;EACjB,iBAAgB;EAChB,YAAW,EACZ","file":"index.scss","sourcesContent":[".scrollableList {\n  max-height: 283px;\n  overflow-y: auto;\n  width: 100%;\n}\n"],"sourceRoot":""}]);

// exports
exports.locals = {
	"scrollableList": "scrollableList___1HHnG"
};


//////////////////
// WEBPACK FOOTER
// ./~/css-loader?{"sourceMap":true,"modules":true,"importLoaders":1,"localIdentName":"[local]___[hash:base64:5]"}!./~/sass-loader/lib/loader.js?{"includePaths":["/Users/fdev/code/factorial/factorial-components/styles"],"sourceMap":true}!./~/postcss-loader/lib?{"path":"/Users/fdev/code/factorial/factorial-components/webpack/postcss.config.js"}!./src/components/ScrollableList/index.scss
// module id = 107
// module chunks = 0